import request from '@/utils/request';
import { message } from 'antd';

const mimeMap = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
};

export function downLoadZip(url: string) {
  request(url, {
    method: 'GET',
    responseType: 'blob',
    getResponse: true,
  }).then((res) => {
    resolveBlob(res, mimeMap.zip);
  });
}

/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob(res: any, mimeType: string) {
  const aLink = document.createElement('a');
  const blob = new Blob([res.data], { type: mimeType });
  // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*');
  const contentDisposition = decodeURI(res.response.headers.get('content-disposition'));
  const result = patt.exec(contentDisposition);
  let fileName = result ? result[1] : 'file';
  fileName = fileName.replace(/"/g, '');
  aLink.style.display = 'none';
  aLink.href = URL.createObjectURL(blob);
  aLink.setAttribute('download', fileName); // 设置下载文件名称
  document.body.appendChild(aLink);
  aLink.click();
  URL.revokeObjectURL(aLink.href); // 清除引用
  document.body.removeChild(aLink);
}

export async function downLoadXlsx(url: string, params: any, fileName: string) {
  return request(url, {
    ...params,
    method: 'POST',
    responseType: 'blob',
  }).then((data) => {
    const aLink = document.createElement('a');
    const blob = data; // new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    aLink.style.display = 'none';
    aLink.href = URL.createObjectURL(blob);
    aLink.setAttribute('download', fileName); // 设置下载文件名称
    document.body.appendChild(aLink);
    aLink.click();
    URL.revokeObjectURL(aLink.href); // 清除引用
    document.body.removeChild(aLink);
  });
}

export async function getDownLoadXlsx(url: string, params: any, fileName: string) {
  return request(url, {
    ...params,
    method: 'GET',
    responseType: 'blob',
    parseResponse: false,
  }).then(async (data: any) => {
    const filename = decodeURI(data.headers.get('download-filename')) || '';
    const aLink = document.createElement('a');
    // const blob = data; // new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const blob = await data.clone().blob();
    aLink.style.display = 'none';
    aLink.href = URL.createObjectURL(blob);
    aLink.setAttribute('download', filename && filename !== 'null' ? filename : fileName); // 设置下载文件名称
    document.body.appendChild(aLink);
    aLink.click();
    URL.revokeObjectURL(aLink.href); // 清除引用
    document.body.removeChild(aLink);
  });
}
export async function getDownLoadDoc(url: string, params: any, fileName: string) {
  return request(url, {
    ...params,
    responseType: 'blob',
    parseResponse: false,
  }).then(async (data: any) => {
    const filename = decodeURI(data.headers.get('download-filename')) || '';
    const aLink = document.createElement('a');
    // const blob = data; // new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const blob = await data.clone().blob();
    aLink.style.display = 'none';
    aLink.href = URL.createObjectURL(blob);
    aLink.setAttribute('download', filename && filename !== 'null' ? filename : fileName); // 设置下载文件名称
    document.body.appendChild(aLink);
    aLink.click();
    URL.revokeObjectURL(aLink.href); // 清除引用
    document.body.removeChild(aLink);
  });
}

export async function getDownLoadTemp(url: string, params: any, fileName: string) {
  return request(url, {
    ...params,
    method: 'GET',
    // responseType: 'blob',
    // parseResponse: false,
  }).then(async (res: any) => {
    if (res.code === '00000') {
      const filename = res?.data?.templateName || `role_${new Date().getTime()}`;
      const href = res?.data?.templateUrl;
      if (!href) return;
      const aLink = document.createElement('a');
      aLink.style.display = 'none';
      aLink.href = href;
      aLink.setAttribute('download', filename && filename !== 'null' ? filename : fileName); // 设置下载文件名称
      document.body.appendChild(aLink);
      aLink.click();
      URL.revokeObjectURL(aLink.href); // 清除引用
      document.body.removeChild(aLink);
    }
    return;
  });
}

export async function createLinkDownload(url: string, fileName: string) {
  if (!url) return;
  const aLink = document.createElement('a');
  aLink.style.display = 'none';
  aLink.href = url;
  aLink.setAttribute('download', fileName || `role_${new Date().getTime()}`);
  // aLink.setAttribute('target', '_blank');
  // aLink.setAttribute('rel', 'noreferrer');
  // aLink.target = '_blank'
  // aLink.rel = 'noreferrer'
  // aLink.download = fileName || `role_${new Date().getTime()}`;
  document.body.appendChild(aLink);
  aLink.click();
  URL.revokeObjectURL(aLink.href); // 清除引用
  document.body.removeChild(aLink);
}

export async function createLinkDownloadXhr(url: string, fileName: string) {
  if (!url) return;
  // 使用xhr下载文件
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = () => {
    // 下载之后生成文件url 模拟a标签点击下载
    const u = window.URL.createObjectURL(xhr.response);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = u;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(a.href); // 清除引用
    document.body.removeChild(a);
    message.destroy();
  };
  xhr.send();
}
